<div class="rescale-works-outer-container">
	<div class="rescale-works-container text-center">
		<h2 class="regscale-works-header">
			How RegScale Works With Your Organization
		</h2>
		<p>
			Understand how our digital compliance solution saves your team
			money, reduces risk, and increases speed of operations.
		</p>
		<div class="row regscale-works-grid">
			<div class="col-xl-3 mb-5">
				<div class="ribbon">
					<svg
						width="324"
						height="89"
						viewBox="0 0 324 89"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M284.768 0.255859L323.81 56.8656H171.672V0.255859H284.768Z"
							fill="url(#paint0_linear_61_2)"
						/>
						<path
							d="M35.0513 0.255859L0.958496 56.8656H147.79V0.255859H35.0513Z"
							fill="url(#paint1_linear_61_2)"
						/>
						<path
							d="M285.321 75.4351C202.809 93.133 117.512 93.133 35 75.4351V75.4351V0.255859H285.321V75.4351Z"
							fill="url(#paint2_linear_61_2)"
						/>
						<defs>
							<linearGradient
								id="paint0_linear_61_2"
								x1="171.505"
								y1="28.8809"
								x2="323.644"
								y2="28.8809"
								gradientUnits="userSpaceOnUse"
							>
								<stop stop-color="#1A70AD" />
								<stop offset="1" stop-color="#2D318D" />
							</linearGradient>
							<linearGradient
								id="paint1_linear_61_2"
								x1="0.797535"
								y1="28.8809"
								x2="147.629"
								y2="28.8809"
								gradientUnits="userSpaceOnUse"
							>
								<stop stop-color="#1A70AD" />
								<stop offset="1" stop-color="#2D318D" />
							</linearGradient>
							<linearGradient
								id="paint2_linear_61_2"
								x1="34.7256"
								y1="44.9825"
								x2="285.047"
								y2="44.9825"
								gradientUnits="userSpaceOnUse"
							>
								<stop stop-color="#1A70AD" />
								<stop offset="1" stop-color="#2D318D" />
							</linearGradient>
						</defs>
					</svg>

					<div class="overlay">Digitize</div>
				</div>

				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="regscale-works-card-inner"
						style="
							background: linear-gradient(
								90deg,
								#1a70ad 0%,
								#2d318d 100%
							);
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-left
							"
						>
							<div
								class="
									d-flex
									align-items-start
									justify-content-center
									mb-4
								"
							>
								<img
									width="34px"
									src="../../assets/img/dollar-coin.png"
									alt=""
								/>
								<div class="ml-3">
									<strong class="regscale-works-card1"
										>Wizards/Builders</strong
									>
									<p>
										Easily create compliance artifacts
										leveraging a guided approach with no
										copy and paste.
									</p>
								</div>
							</div>
							<div
								class="
									d-flex
									align-items-start
									justify-content-center
									mb-4
								"
							>
								<img
									width="34px"
									src="../../assets/img/stop-watch.png"
									alt=""
								/>
								<div class="ml-3">
									<strong class="regscale-works-card1"
										>Compliance Concierge
									</strong>
									<p>
										Turn-key onboarding of your existing
										compliance artifacts into the platform.
									</p>
								</div>
							</div>
							<div
								class="
									d-flex
									align-items-start
									justify-content-center
								"
							>
								<img
									width="34px"
									src="../../assets/img/stop-watch.png"
									alt=""
								/>
								<div class="ml-3">
									<strong class="regscale-works-card1"
										>Rapid Time to Value
									</strong>
									<p>
										Deploy in under an hour on any platform
										(on premises, cloud, or air-gapped) with
										no developers.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="regscale-works-card-bottom">
					<div
						class="regscale-works-circle"
						style="
							background: linear-gradient(
								90deg,
								#1a70ad 0%,
								#2d318d 100%
							);
						"
					>
						<div class="regscale-works-inner-circle">
							<img
								width="40px"
								src="../../assets/img/digitize.png"
								alt=""
							/>
						</div>
					</div>
				</div>
			</div>

			<div class="col-xl-3 mb-5">
				<div class="ribbon">
					<svg
						width="324"
						height="89"
						viewBox="0 0 324 89"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M284.768 0.255859L323.81 56.8656H171.672V0.255859H284.768Z"
							fill="url(#paint0_linear_66_3)"
						/>
						<path
							d="M35.0513 0.255859L0.958496 56.8656H147.79V0.255859H35.0513Z"
							fill="url(#paint1_linear_66_3)"
						/>
						<path
							d="M285.321 75.4351C202.809 93.133 117.512 93.133 35 75.4351V0.255859H285.321V75.4351Z"
							fill="url(#paint2_linear_66_3)"
						/>
						<defs>
							<linearGradient
								id="paint0_linear_66_3"
								x1="171.505"
								y1="28.8809"
								x2="323.644"
								y2="28.8809"
								gradientUnits="userSpaceOnUse"
							>
								<stop stop-color="#F3931F" />
								<stop offset="0.5" stop-color="#EF5A23" />
								<stop offset="1" stop-color="#9E0E5D" />
							</linearGradient>
							<linearGradient
								id="paint1_linear_66_3"
								x1="0.797535"
								y1="28.8809"
								x2="147.629"
								y2="28.8809"
								gradientUnits="userSpaceOnUse"
							>
								<stop stop-color="#F3931F" />
								<stop offset="0.5" stop-color="#EF5A23" />
								<stop offset="1" stop-color="#9E0E5D" />
							</linearGradient>
							<linearGradient
								id="paint2_linear_66_3"
								x1="34.7256"
								y1="44.9825"
								x2="285.047"
								y2="44.9825"
								gradientUnits="userSpaceOnUse"
							>
								<stop stop-color="#F3931F" />
								<stop offset="0.5" stop-color="#EF5A23" />
								<stop offset="1" stop-color="#9E0E5D" />
							</linearGradient>
						</defs>
					</svg>

					<div class="overlay">Automate</div>
				</div>

				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="regscale-works-card-inner"
						style="
							background: linear-gradient(
								90deg,
								#f3931f 0%,
								#ef5a23 0%,
								#9e0e5d 100%
							);
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-left
							"
						>
							<div
								class="
									d-flex
									align-items-start
									justify-content-center
									mb-4
								"
							>
								<img
									width="34px"
									src="../../assets/img/umbrella.png"
									alt=""
								/>
								<div class="ml-3">
									<strong class="regscale-works-card2"
										>Integrate</strong
									>
									<p>
										Leverage our APIs to increase the value
										of cyber scanning tools and update your
										compliance paperwork in real-time.
									</p>
								</div>
							</div>
							<div
								class="
									d-flex
									align-items-start
									justify-content-center
									mb-4
								"
							>
								<img
									width="34px"
									src="../../assets/img/stop-watch.png"
									alt=""
								/>
								<div class="ml-3">
									<strong class="regscale-works-card2"
										>RegOps
									</strong>
									<p>
										Automate handoffs between cyber security
										and operations when issues are detected,
										enabling cyber information assurance and
										engineering staff to work
										collaboratively together with automated
										workflow.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="regscale-works-card-bottom">
					<div
						class="regscale-works-circle"
						style="
							background: linear-gradient(
								90deg,
								#f3931f 0%,
								#ef5a23 0%,
								#9e0e5d 100%
							);
						"
					>
						<div class="regscale-works-inner-circle">
							<img
								width="40px"
								src="../../assets/img/automate.png"
								alt=""
							/>
						</div>
					</div>
				</div>
			</div>

			<div class="col-xl-3 mb-5">
				<div class="ribbon">
					<svg
						width="324"
						height="89"
						viewBox="0 0 324 89"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M284.768 0.255859L323.81 56.8656H171.672V0.255859H284.768Z"
							fill="url(#paint0_linear_66_4)"
						/>
						<path
							d="M35.0513 0.255859L0.958496 56.8656H147.79V0.255859H35.0513Z"
							fill="url(#paint1_linear_66_4)"
						/>
						<path
							d="M285.321 75.4351C202.809 93.133 117.512 93.133 35 75.4351V0.255859H285.321V75.4351Z"
							fill="url(#paint2_linear_66_4)"
						/>
						<defs>
							<linearGradient
								id="paint0_linear_66_4"
								x1="171.505"
								y1="28.8809"
								x2="323.644"
								y2="28.8809"
								gradientUnits="userSpaceOnUse"
							>
								<stop stop-color="#1A70AD" />
								<stop offset="1" stop-color="#2AA4CA" />
							</linearGradient>
							<linearGradient
								id="paint1_linear_66_4"
								x1="0.797535"
								y1="28.8809"
								x2="147.629"
								y2="28.8809"
								gradientUnits="userSpaceOnUse"
							>
								<stop stop-color="#1A70AD" />
								<stop offset="1" stop-color="#2AA4CA" />
							</linearGradient>
							<linearGradient
								id="paint2_linear_66_4"
								x1="35"
								y1="44.4822"
								x2="285.321"
								y2="44.4822"
								gradientUnits="userSpaceOnUse"
							>
								<stop stop-color="#29ABE2" />
								<stop offset="1" stop-color="#0EC7BE" />
							</linearGradient>
						</defs>
					</svg>

					<div class="overlay">Transform</div>
				</div>

				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="regscale-works-card-inner"
						style="
							background: linear-gradient(
								90deg,
								#1a70ad 0%,
								#2aa4ca 100%
							);
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-left
							"
						>
							<div
								class="
									d-flex
									align-items-start
									justify-content-center
									mb-4
								"
							>
								<img
									width="34px"
									src="../../assets/img/dollar-coin.png"
									alt=""
								/>
								<div class="ml-3">
									<strong class="regscale-works-card3"
										>Transformer</strong
									>
									<p>
										Reuse your artifacts from one framework
										to another in real-time with our drag
										and drop mapping tools, reducing the
										burden of complying with multiple
										regulations manually, all while
										leveraging the same audits/evidence
										(assess once/use many).
									</p>
								</div>
							</div>
							<div
								class="
									d-flex
									align-items-start
									justify-content-center
									mb-4
								"
							>
								<img
									width="34px"
									src="../../assets/img/stop-watch.png"
									alt=""
								/>
								<div class="ml-3">
									<strong class="regscale-works-card3"
										>Compatibility
									</strong>
									<p>
										Leverage our best-in-class industry
										support for OSCAL to automate compliance
										checks using digital tools.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="regscale-works-card-bottom">
					<div
						class="regscale-works-circle"
						style="
							background: linear-gradient(
								90deg,
								#1a70ad 0%,
								#2aa4ca 100%
							);
						"
					>
						<div class="regscale-works-inner-circle">
							<img
								width="40px"
								src="../../assets/img/transform.png"
								alt=""
							/>
						</div>
					</div>
				</div>
			</div>

			<div class="col-xl-3 mb-5">
				<div class="ribbon">
					<div class="ribbon4">
						<svg
							width="324"
							height="89"
							viewBox="0 0 324 89"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M284.768 0.255859L323.81 56.8656H171.672V0.255859H284.768Z"
								fill="url(#paint0_linear_66_6)"
							/>
							<path
								d="M35.0513 0.255859L0.958496 56.8656H147.79V0.255859H35.0513Z"
								fill="url(#paint1_linear_66_6)"
							/>
							<path
								d="M285.321 75.4351C202.809 93.133 117.512 93.133 35 75.4351V75.4351V0.255859H285.321V75.4351Z"
								fill="url(#paint2_linear_66_6)"
							/>
							<defs>
								<linearGradient
									id="paint0_linear_66_6"
									x1="171.505"
									y1="28.8809"
									x2="323.644"
									y2="28.8809"
									gradientUnits="userSpaceOnUse"
								>
									<stop stop-color="#F9CA2D" />
									<stop offset="0.5" stop-color="#F8B03B" />
									<stop offset="1" stop-color="#F3931F" />
								</linearGradient>
								<linearGradient
									id="paint1_linear_66_6"
									x1="0.797535"
									y1="28.8809"
									x2="147.629"
									y2="28.8809"
									gradientUnits="userSpaceOnUse"
								>
									<stop stop-color="#F9CA2D" />
									<stop offset="0.5" stop-color="#F8B03B" />
									<stop offset="1" stop-color="#F3931F" />
								</linearGradient>
								<linearGradient
									id="paint2_linear_66_6"
									x1="34.7256"
									y1="44.9825"
									x2="285.047"
									y2="44.9825"
									gradientUnits="userSpaceOnUse"
								>
									<stop stop-color="#F9CA2D" />
									<stop offset="0.5" stop-color="#F8B03B" />
									<stop offset="1" stop-color="#F3931F" />
								</linearGradient>
							</defs>
						</svg>
					</div>
					<div class="ribbon4-mobile">
						<svg
							width="324"
							height="89"
							viewBox="0 0 278 77"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M244.389 0.558594L277.926 49.1868H147.238V0.558594H244.389Z"
								fill="url(#paint0_linear_241_3)"
							/>
							<path
								d="M29.8798 0.558594L0.59375 49.1868H126.723V0.558594H29.8798Z"
								fill="url(#paint1_linear_241_3)"
							/>
							<path
								d="M244.864 65.1381C173.985 80.3408 100.714 80.3408 29.8359 65.1381V0.558594H244.864V65.1381Z"
								fill="url(#paint2_linear_241_3)"
							/>
							<defs>
								<linearGradient
									id="paint0_linear_241_3"
									x1="147.095"
									y1="25.1477"
									x2="277.783"
									y2="25.1477"
									gradientUnits="userSpaceOnUse"
								>
									<stop stop-color="#39D90D" />
									<stop offset="0.5" stop-color="#39AD19" />
									<stop offset="1" stop-color="#296817" />
								</linearGradient>
								<linearGradient
									id="paint1_linear_241_3"
									x1="0.455483"
									y1="25.1477"
									x2="126.585"
									y2="25.1477"
									gradientUnits="userSpaceOnUse"
								>
									<stop stop-color="#39D90D" />
									<stop offset="0.5" stop-color="#39AD19" />
									<stop offset="1" stop-color="#296817" />
								</linearGradient>
								<linearGradient
									id="paint2_linear_241_3"
									x1="29.6002"
									y1="38.9791"
									x2="244.628"
									y2="38.9791"
									gradientUnits="userSpaceOnUse"
								>
									<stop stop-color="#39D90D" />
									<stop offset="0.5" stop-color="#39AD19" />
									<stop offset="1" stop-color="#296817" />
								</linearGradient>
							</defs>
						</svg>
					</div>

					<div class="overlay">Scale</div>
				</div>

				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div class="regscale-works-card-inner card4-inner">
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-left
							"
						>
							<div
								class="
									d-flex
									align-items-start
									justify-content-center
									mb-4
								"
							>
								<img
									width="34px"
									src="../../assets/img/umbrella.png"
									alt=""
								/>
								<div class="ml-3">
									<strong class="regscale-works-card4"
										>Business Intelligence
									</strong>
									<p>
										Visualize your risk and compliance in
										real-time across the entire organization
										with no manual reporting processes.
									</p>
								</div>
							</div>
							<div
								class="
									d-flex
									align-items-start
									justify-content-center
									mb-4
								"
							>
								<img
									width="34px"
									src="../../assets/img/stop-watch.png"
									alt=""
								/>
								<div class="ml-3">
									<strong class="regscale-works-card4"
										>Multi-Tenancy
									</strong>
									<p>
										Stand up tenants for each business unit,
										delivering consolidation of tools while
										enabling freedom in the business units
										to execute their unique processes.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="regscale-works-card-bottom">
					<div class="regscale-works-circle card4-circle">
						<div class="regscale-works-inner-circle">
							<img
								class="d-none d-xl-block"
								width="40px"
								src="../../assets/img/scale.png"
								alt=""
							/>
							<img
								class="d-block d-xl-none"
								width="40px"
								src="../../assets/img/scale-green.png"
								alt=""
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			class="
				d-flex
				flex-column flex-md-row
				justify-content-center
				regscale-works-bottom
			"
		>
			<div
				class="
					d-flex
					justify-content-md-center
					align-items-center
					mb-3 mb-md-0
					mx-md-4
				"
			>
				<div class="regscale-works-inner-circle p-2 mr-3">
					<img
						width="30px"
						src="../../assets/img/dollar-coin.png"
						alt=""
					/>
				</div>
				<p class="m-0 regscale-works-label">Save Money</p>
			</div>
			<div
				class="
					d-flex
					justify-content-md-center
					align-items-center
					mb-3 mb-md-0
					mx-md-4
				"
			>
				<div class="regscale-works-inner-circle p-2 mr-3">
					<img
						width="27px"
						src="../../assets/img/umbrella.png"
						alt=""
					/>
				</div>
				<p class="m-0 regscale-works-label">Reduce Risk</p>
			</div>
			<div
				class="
					d-flex
					justify-content-md-center
					align-items-center
					mb-3 mb-md-0
					mx-md-4
				"
			>
				<div class="regscale-works-inner-circle p-2 mr-3">
					<img
						width="30px"
						src="../../assets/img/stop-watch.png"
						alt=""
					/>
				</div>
				<p class="m-0 regscale-works-label">Increase Speed</p>
			</div>
		</div>
	</div>
</div>
